// Copy only: never remove outliers or change series values/thresholds.
export function inpOutlierNote(spread, language = 'en') {
  const ids = new Set(spread?.outlierIds || []);
  const observed = (spread?.attempts || []).some(a =>
    a.status === 'ok' && a.conditionMismatch !== true && a.conditionsIncomplete !== true
    && typeof a.value === 'number' && a.value > 200
    && (a.outlier === true || ids.has(a.id)));
  if (!observed) return '';
  return language === 'cs'
    ? ' Mezi platnými běhy nad prahem je i statisticky odlehlý pokus.'
    : ' The valid runs above the threshold include a statistically outlying attempt.';
}
